import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";
import type { CertificateRequest } from "../user/getCertificateRequests";

/**
 * Obtiene todas las solicitudes de certificados que requieren aprobación de Manager
 * Solo muestra las que ya fueron aprobadas por RRHH
 */
export const getManagerPendingRequests = async () => {
    try {
        const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
        const collectionId = import.meta.env.VITE_CERTIFICATE_REQUESTS_COLLECTION_ID;

        if (!databaseId || !collectionId) {
            throw new Error("Missing environment variables for database or collection");
        }

        // Obtener solicitudes donde:
        // 1. RRHH ya aprobó (statusByRrhh = 'approved')
        // 2. El tipo de certificado requiere aprobación de manager (with_salary)
        const response = await databases.listDocuments(
            databaseId,
            collectionId,
            [
                Query.equal('statusByRrhh', 'approved'),
                Query.equal('statusByManager', 'pending'), // ✓ Trae todos los pending

                Query.orderDesc('requestDate')
            ]
        );

        return {
            success: true,
            data: response.documents as unknown as CertificateRequest[]
        };

    } catch (error) {
        console.error("Error fetching manager pending requests:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : "Error desconocido al obtener las solicitudes",
            data: []
        };
    }
};